export const NEXT_ACTION = 'nextAction';

export const HOST_CLICKED = 'hostClicked';

export const HOST_CHANGED = 'hostChanged';
